module.exports = __webpack_public_path__ + "static/fr-a0e9401920e242f751c9d6787002fd1f.mp4";